module.exports = [
  require('./the_angry'),
  require('./the_hungry'),
  require('./the_lost'),
  require('./the_wretched'),
  require('./titivilus'),
  require('./tortle'),
  require('./tortle_druid'),
]
